import * as React from "react";
import { ArrowRight, Cpu, Globe2, Hospital, Microscope } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
const expansionInitiatives = [{
  id: "research-labs",
  title: "DATS3 Peptide Technology",
  description: "DATS3 peptide developed with CSIC Spain and the University of Madrid, in partnership with MedicZen. Formulated for intra and extracellular activity, with next steps in nutraceuticals and biotech applications.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/advanced_research_labs_facility.png",
  icon: Microscope,
  linkUrl: "/TeamAndPartnersPage",
  linkText: "View Facilities"
}, {
  id: "strategic-partnerships",
  title: "Medical Centers Expansion",
  description: "Expanding medical centers increases patient data volume, enabling continuous development and real-world validation of AI healthcare applications at scale.\n",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/busy_medical_center_staff_patients.png",
  icon: Hospital,
  linkUrl: "/TeamAndPartnersPage",
  linkText: "Our Partners"
}, {
  id: "global-network",
  title: "MAIDA AI Cloud Infrastructure",
  description: "All healthcare solutions are hosted on MAIDA sovereign AI cloud, ensuring scalability, performance, data control and enabling SaaS deployment across Africa and beyond.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581901/img/ai_datacenter.png",
  icon: Cpu,
  linkUrl: "/TokenomicsAndGrowthPage",
  linkText: "Growth Strategy"
}];
export default function EcosystemExpansion() {
  return <section id="ecosystem-expansion" className="bg-background w-full">
      <div className="bg-accent w-full py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground tracking-tight mb-6">
              Ecosystem Expansion
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
              Scaling our infrastructure and forging strategic alliances to build a comprehensive, globally accessible healthcare network powered by AI.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {expansionInitiatives.map((initiative, index) => <div data-index={index} key={initiative.id} className="h-full">
                <Card className="group relative overflow-hidden border-none shadow-md transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-2xl bg-card flex flex-col h-full rounded-2xl">
                  <div className="relative h-64 w-full overflow-hidden bg-muted">
                    <img src={initiative.image} alt={initiative.title} className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" />
                    <div className="absolute top-6 right-6 bg-background/95 backdrop-blur-md p-3 rounded-2xl shadow-sm border border-border/50 transition-transform duration-300 group-hover:scale-110">
                      <initiative.icon className="w-6 h-6 text-primary" strokeWidth={2} />
                    </div>
                  </div>
                  
                  <CardContent className="p-8 flex-grow flex flex-col">
                    <h3 className="text-2xl font-bold text-foreground mb-4 leading-tight">
                      {initiative.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed mb-8 flex-grow text-base">
                      {initiative.description}
                    </p>
                    
                    {index !== 0 && index !== 1 && index !== 2 && <div className="mt-auto pt-4 border-t border-border/40">
                        <Button variant="ghost" className="w-fit group/btn px-0 hover:bg-transparent text-primary font-semibold text-base" asChild>
                          <Link to={initiative.linkUrl}>
                            {initiative.linkText}
                            <ArrowRight className="w-5 h-5 ml-2 transition-transform duration-300 group-hover/btn:translate-x-1.5" />
                          </Link>
                        </Button>
                      </div>}
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}